// Copyright 2020 Drivetrain Hub LLC
// GraphQL request helpers for library data (gears, tools, NOT models).

import gear from "./gear";
import tool from "./tool";

const LIMIT = 200;  // limit number of items queried in collection

// region BASE

const LibraryMaster = `
  Id
  createdBy
  createdOn
  description
  image
  lastModifiedBy
  lastModifiedOn
  lock
  name
  number
  owner
  shared`;

const masterCollectionFields = `
  Id
  name
  number
  owner`;

// endregion

// region GEARS

const gearDetailCollectionFields = `
  ${masterCollectionFields}
  geom {
    numberOfTeeth
    helixAngle
    moduleNormal
    pressureAngleNormal
  }`;

const GearDetail = `
  ${LibraryMaster}
  ${gear.GearDetail}`;

// endregion

// region FRAME

const Frame = `
  ${LibraryMaster}
  ${gear.Frame}`;

// endregion

// region BASIC RACKS

const basicRackCollectionFields = `
  ${masterCollectionFields}
  geom {
    addendumCoefficient
    dedendumCoefficient
    moduleNormal
    pressureAngle
  }`;

const BasicRack = `
  ${LibraryMaster}
  ${tool.BasicRack}`;

// endregion

// region HOBS

const hobCollectionFields = `
  ${masterCollectionFields}
  geom {
    addendumCoefficient
    dedendumCoefficient
    moduleNormal
    pressureAngleNormal
  }`;

const Hob = `
  ${LibraryMaster}
  ${tool.Hob}`;

// endregion

// region SHAPERS

const pinionCutterCollectionFields = `
  ${masterCollectionFields}
  geom {
    addendumCoefficient
    helixAngle
    moduleNormal
    pressureAngleNormal
  }`;

const PinionCutter = `
  ${LibraryMaster}
  ${tool.PinionCutter}`;

// endregion

export default {
  LIMIT: LIMIT,
  LibraryMaster: LibraryMaster,
  // GEARS
  GearDetail: GearDetail,
  gearDetailCollectionFields: gearDetailCollectionFields,
  // FRAME
  Frame: Frame,
  // BASIC RACK
  BasicRack: BasicRack,
  basicRackCollectionFields: basicRackCollectionFields,
  // HOB
  Hob: Hob,
  hobCollectionFields: hobCollectionFields,
  // SHAPER
  PinionCutter: PinionCutter,
  pinionCutterCollectionFields: pinionCutterCollectionFields,
}
